import { render, staticRenderFns } from "./ColorSelector.vue?vue&type=template&id=a73cad6a"
import script from "./ColorSelector.vue?vue&type=script&lang=ts"
export * from "./ColorSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports